export default __webpack_public_path__ + "static/media/Delivery_HTB.b75753e5.md";